// Text input for sensitive merchant values (tax ID, SSN, account,
// routing, DL). Digits stay visible — password-style dots belong on
// passwords, not identifiers the operator or merchant has to verify.
//
// Security is HTTPS + we don't persist the full value (last 4 only)
// + autocomplete off so password managers don't dump a card number
// into an SSN box.

import type { ChangeEvent } from "react";

interface Props {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  required?: boolean;
  inputMode?: "text" | "numeric" | "decimal";
  pattern?: string;
  ariaInvalid?: boolean;
  ariaDescribedBy?: string;
  ariaLabel?: string;
  /** Kept for call-site compatibility (intake censored last-4). The
   *  value is always shown as plaintext now; this flag is a no-op. */
  alwaysVisible?: boolean;
}

export function SensitiveField({
  id,
  value,
  onChange,
  placeholder,
  maxLength,
  required,
  inputMode = "numeric",
  ariaInvalid,
  ariaDescribedBy,
  ariaLabel,
}: Props) {
  return (
    <input
      id={id}
      type="text"
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) =>
        onChange(e.target.value)
      }
      placeholder={placeholder}
      maxLength={maxLength}
      inputMode={inputMode}
      aria-required={required || undefined}
      aria-invalid={ariaInvalid || undefined}
      aria-describedby={ariaDescribedBy}
      aria-label={ariaLabel}
      autoComplete="off"
      data-1p-ignore="true"
      data-lpignore="true"
      className="input"
    />
  );
}
